import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-cloud-upload-icon',
  templateUrl: './files-cloud-upload.component.html'
})
export class FilesCloudUploadComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
